// import { Helmet } from "react-helmet-async";

// export default function MetaInfo({
//     title,
//     description,
//     keywords,
//     image,
//     url,
// }) {
//     return (
//         <Helmet>
//             <title>{title}</title>

//             <meta name="description" content={description} />
//             <meta name="keywords" content={keywords} />

//             {/* Open Graph */}
//             <meta property="og:title" content={title} />
//             <meta property="og:description" content={description} />
//             <meta property="og:image" content={image} />
//             <meta property="og:url" content={url} />

//             {/* Twitter */}
//             <meta name="twitter:card" content="summary_large_image" />
//             <meta name="twitter:title" content={title} />
//             <meta name="twitter:description" content={description} />
//             <meta name="twitter:image" content={image} />

//             <link rel="canonical" href={url} />
//         </Helmet>
//     );
// }

import { Head } from 'vite-react-ssg'
import { useLocation } from 'react-router-dom'
import { SITE } from '@/constants'

const toAbsoluteUrl = (path) => (path.startsWith('http') ? path : `${SITE.url}${path}`)

export default function MetaInfo({
  title,
  description,
  keywords,
  image = SITE.ogImage,
  url,
  type = 'website',
  noIndex = false,
  // referrerPolicy,
}) {
  const { pathname } = useLocation()
  const canonicalUrl = url ?? toAbsoluteUrl(pathname === '/' ? '/' : pathname.replace(/\/$/, ''))
  const imageUrl = toAbsoluteUrl(image)

  return (
    <Head>
      <title>{title} {SITE.metaTagPostText}</title>
      <meta name="description" content={description} />
      {/* {keywords && <meta name="keywords" content={keywords} />} */}
      {/* {noIndex && <meta name="robots" content="noindex, nofollow" />} */}
      
      {/* {referrerPolicy && <meta name="referrer" content={referrerPolicy} />} */}
      <meta name="referrer" content="no-referrer-when-downgrade" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.fullName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} /> */}
    </Head>
  )
}